<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange = 'DataOnChange'
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xoá nhóm quyền này không?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
export default {
  components: {
    BaseDatatable,
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      }
    }
  },
  mounted () {
    this.initParams();
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.list_group && that.$store.getters.controllers?.list_group.includes('add')) {
        actions.header = {name: 'add', icon: 'plus', path: `list-group/add`};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.$store.getters.controllers?.list_group && that.$store.getters.controllers?.list_group.includes('edit')) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-group/edit/`};
        }
        if (that.$store.getters.controllers?.list_group && that.$store.getters.controllers?.list_group.includes('delete')) {
          if(rowData.group_no_delete == false){
            buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
          }
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    //   var attributes = [];
    //   for (let index = 0; index < fields.length; index++) {
    //     const element = fields[index];
    //     if (element.models !== undefined && element.models !== null) {
    //       // console.log("SDFGHJK",element)
    //       var optionsData = [];
    //       attributes.push(element.models.key.key);
    //       attributes.push(element.models.display_key);
    //       var where_ = {}
    //       if( element['name']== "name_country"){
    //         // console.log("element",element)
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList("country", {"fields" : "id country_lang{lang name}"}),
    //           variables: {
    //             where_key : {
    //               deleted : {_eq: false}
    //             },
    //             orderBy:[{ordinal: 'desc'},{created_at : 'desc'}]
    //           }
    //         })
    //         if (data) {
    //           var ress = data[Object.keys(data)];
    //           if (ress) {
    //             for (let index = 0; index < ress.length; index++) {
    //               const ele = ress[index];
    //               var name_country = ''
    //               if(ele.country_lang){
    //                 for (let j = 0; j < ele.country_lang.length; j++) {
    //                   if(ele.country_lang[j].lang == 'en'){
    //                     name_country = ele.country_lang[j].name;
    //                     break;
    //                   }
    //                 }
    //               }
    //               if(name_country !== ''){
    //                 optionsData.push({value: ele.id, label: name_country})
    //               }
    //             }
    //           }
    //         }
    //       }else{
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
    //           variables: {where_key : where_}
    //         })
    //         if (data) {
    //           var result = data[Object.keys(data)];
    //           if (result) {
    //             for (let index = 0; index < result.length; index++) {
    //               const ele = result[index];
    //               optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
    //             }
    //           }
    //         }
    //       }
    //       // console.log("optionsData",optionsData)
    //       this.options[element.key] = optionsData;
    //     }
    //     this.componentKey++;
    //   }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'calculator':
          this.dialogMode = action.name
          this.$router.push({ path: action.path, query: { group_id: data.data[action.key] }  })
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/group/delete", {group_id: that.deleteId}, {headers}).then(function () {
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            })
        })
      }
    }
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
</style>